import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { LockResetOutlinedIcon } from 'icons/materialIcons';

const TeamPasswordResetHeader = () => {
    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#333' }}>
                Password Reset
            </Typography>
            <Button variant="contained" startIcon={<LockResetOutlinedIcon />}>
                Reset Policy
            </Button>
        </Box>
    );
};

export default TeamPasswordResetHeader;

